module.exports = __webpack_public_path__ + "static/bg-showcase-2-37b5a1e70d28e0251d4dbe331de3db29.jpg";